import { Plus, Sparkles } from "lucide-react";
import { useCart } from "../lib/cart";
import { DishImage, slugOf } from "./MenuCard";

function ComboCard({ item, unavailableLabel }) {
  const { add, qtyFor } = useCart();
  const qty = qtyFor(item.id);
  const slug = slugOf(item.name);
  const blocked = !!item.sold_out;
  return (
    <div data-testid={`combo-card-${slug}`} className="group w-[260px] sm:w-[300px] shrink-0 bg-[#1C1C1C] rounded-2xl overflow-hidden border border-white/10">
      <div className="relative">
        <DishImage item={item} className="aspect-[16/10]" />
        {blocked && <div className="absolute inset-0 bg-black/55 grid place-items-center p-2" data-testid={`combo-unavailable-${slug}`}><span className="bg-white text-black text-xs font-bold uppercase px-3 py-1 rounded-full text-center max-w-full break-words">{unavailableLabel}</span></div>}
      </div>
      <div className="p-4">
        <div className="font-display font-bold text-white leading-tight">{item.name.replace("MLOBOX ", "")}</div>
        <div className="text-xs text-white/60 mt-1 line-clamp-2 min-h-[32px]">{item.description}</div>
        <div className="flex items-center justify-between mt-3">
          <div className="font-extrabold text-[#FF8A3D]">KSh {item.price}</div>
          <button data-testid={`combo-add-${slug}`} disabled={blocked} onClick={() => add(item)}
            className="relative mlobox-gradient text-white rounded-full px-4 py-1.5 text-sm font-semibold flex items-center gap-1 disabled:grayscale">
            <Plus size={14} /> Add
            {qty > 0 && <span className="absolute -top-2 -right-2 bg-white text-black text-[10px] h-5 min-w-5 px-1 rounded-full grid place-items-center">{qty}</span>}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function CombosShowcase({ combos, unavailableLabel }) {
  if (!combos.length) return null;
  return (
    <section data-testid="combos-showcase" className="max-w-6xl mx-auto px-4 pt-6">
      <div className="bg-[#111111] rounded-3xl p-5 sm:p-7 relative overflow-hidden">
        <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-[#FF6600]/20 blur-3xl" />
        <div className="relative flex items-end justify-between mb-4">
          <div>
            <div className="text-[#FF8A3D] text-xs font-bold uppercase tracking-[0.2em] flex items-center gap-1.5"><Sparkles size={12} /> Only at MLOBOX</div>
            <h2 className="font-display text-white text-2xl sm:text-3xl font-extrabold mt-1">Signature Combos</h2>
          </div>
        </div>
        <div className="relative flex gap-4 overflow-x-auto pb-3 -mx-1 px-1 combos-scroll" data-testid="combos-row">
          {combos.map((c) => <ComboCard key={c.id} item={c} unavailableLabel={unavailableLabel} />)}
        </div>
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-[#111111] to-transparent rounded-r-3xl" />
      </div>
    </section>
  );
}
